import { DeclarationStatus } from '@enums/declaration-status.enum';

export const DECLARATION_STATUS_LABEL: Record<DeclarationStatus, string> = {
  [DeclarationStatus.sentWithoutTeletransmission]: 'Accepté',
  [DeclarationStatus.accepted]: 'Accepté',
  [DeclarationStatus.done]: 'Terminé',
  [DeclarationStatus.sent]: 'Télétransmis',
  [DeclarationStatus.transmitted]: 'Télétransmis',
  [DeclarationStatus.readyToBeSent]: 'À envoyer',
  [DeclarationStatus.refused]: 'Refusé',
  [DeclarationStatus.declined]: 'Refusé',
  [DeclarationStatus.docRequested]: 'Docs. demandés',
  [DeclarationStatus.toCheck]: 'À vérifier',
  [DeclarationStatus.toVerify]: 'À vérifier',
  [DeclarationStatus.toCorrect]: 'À corriger',
  [DeclarationStatus.toFix]: 'À corriger',
  [DeclarationStatus.toSupervise]: 'À superviser',
  [DeclarationStatus.waitingClient]: 'En attente client',
  [DeclarationStatus.toBeReturned]: 'À restituer',
  [DeclarationStatus.clientValidationRequested]: 'Validation client',
  [DeclarationStatus.preDraft]: 'À faire',
  [DeclarationStatus.draft]: 'À faire',
  [DeclarationStatus.toDo]: 'À faire',
  [DeclarationStatus.ignored]: 'Ignoré'
};
